import { AgendarCitaProvider, useAgendarCita } from './AgendarCitaContext';
import ConfirmationView from './views/ConfirmationView';
import FormView from './views/FormView';
import StepperView from './views/StepperView';
import SelectCita from './views/SelectCita';

import {
  ConfirmacionCitaModal,
  CreateCitaResponseModal,
  FormResponseModal,
} from './views/Modals';
import { useLayoutEffect } from 'react';

const View = () => {
  const { view } = useAgendarCita();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [view]);

  switch (view) {
    case 'formView':
      return <FormView />;
    case 'selectCita':
      return <SelectCita />;
    case 'confirmationView':
      return <ConfirmationView />;
    case 'stepperView':
      return <StepperView />;
    default:
      return null;
  }
};

function AgendarCita() {
  return (
    <AgendarCitaProvider>
      <FormResponseModal />
      <ConfirmacionCitaModal />
      <CreateCitaResponseModal />
      <View />
    </AgendarCitaProvider>
  );
}

export default AgendarCita;
